import React, { useEffect, useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { Link, useHistory, withRouter } from "react-router-dom";
import { isEmpty } from "lodash";
import * as moment from "moment";
import axios from "axios";
// import { axiosIns } from '../../utils'
// Import Images
import dummyImg from "../../../assets/images/users/user-dummy-img.jpg";

import
{
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  ModalFooter,
  Table,
  FormFeedback,
  Button,
} from "reactstrap";
import Select from "react-select";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";

//Import actions
import
{
  getClients as onGetClients,
  addNewClient as onAddNewClient,
  updateClient as onUpdateClient,
} from "../../../store/actions";
//redux
import TableContainer from "../../../Components/Common/TableContainer";
import { useSelector, useDispatch } from "react-redux";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import Loader from "../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReducer } from "react";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../axiosConfig";

const Client = ( props ) =>
{
  const history = useHistory();
  const dispatch = useDispatch();

  const [ loading, setLoading ] = useState( true );
  const [ clients, setClients ] = useState( [] );

  const fetchClientList = async () =>
  {
    try
    {
      const dataClient = await axiosInstance.get( `clientlist/` );
      // console.log( 'dataClient: ', dataClient )
      console.log( 'dataClient data: ', dataClient.data.data )
      setClients( dataClient.data.data );
    } catch ( err )
    {
      console.error( err );
    }
    setLoading( false );
  };

  useEffect( () =>
  {
    try
    {
      fetchClientList();
    } catch ( error )
    {
      console.error( "Erreur de fetch client list: ", error );
    }
  }, [] );

  const token = JSON.parse( localStorage.getItem( "authUser" ) )
    ? JSON.parse( localStorage.getItem( "authUser" ) ).accessToken
    : null;
  // const { clients, isClientCreated, isClientSuccess, error } = useSelector(
  //   ( state ) => ( {
  //     clients: state.Client.clients,
  //     isClientCreated: state.Client.isClientCreated,
  //     isClientSuccess: state.Client.isClientSuccess,
  //     error: state.Client.error,
  //   } )
  // );

  const [ isEdit, setIsEdit ] = useState( false );
  const [ client, setClient ] = useState( [] );

  //delete Conatct
  const [ deleteModal, setDeleteModal ] = useState( false );
  const [ deleteModalMulti, setDeleteModalMulti ] = useState( false );
  const [ modal, setModal ] = useState( false );
  const [ isExportCSV, setIsExportCSV ] = useState( false );

  const [ reducerValue, forceUpdate ] = useReducer( ( x ) => x + 1, 0 );


  const toggle = useCallback( () =>
  {
    if ( modal )
    {
      setModal( false );
      setClient( null );
    } else
    {
      setModal( true );
    }
  }, [ modal ] );

  const onClickDelete = ( client ) =>
  {
    setClient( client );
    setDeleteModal( true );
  };

  // Add Data
  const handleClientClicks = () =>
  {
    setClient( "" );
    setIsEdit( false );
    toggle();
  };

  const handleaccept = ( e ) =>
  {
    axiosInstance
      .put( `/clientetat/?id=${ e }`, {
        etat: "Activer",
      } )
      .then( ( res ) =>
      {
        // console.log(res);
        toast.success( "Client activé avec succès" );
        fetchClientList();
      } )
      .catch( ( err ) =>
      {
        console.error( err );
        toast.error( "Erreur lors de l'activation du client" );
      } );
  };

  const handlerefuse = ( id_client ) =>
  {
    axiosInstance
      .put( `/clientetat/?id=${ id_client }`, {
        etat: "Desactiver",
      } )
      .then( ( res ) =>
      {
        // console.log(res);
        toast.success( "Client désactivé avec succès" );
        ( fetchClientList() );
      } )
      .catch( ( err ) =>
      {
        console.error( err );
        toast.error( "Erreur lors de la désactivation du client" );
      } );
  };

  // const handleValidDate = date => {
  //   const date1 = moment(new Date(date)).format("DD MMM Y");
  //   return date1;
  // };

  // const handleValidTime = (time) => {
  //   const time1 = new Date(time);
  //   const getHour = time1.getUTCHours();
  //   const getMin = time1.getUTCMinutes();
  //   const getTime = `${getHour}:${getMin}`;
  //   var meridiem = "";
  //   if (getHour >= 12) {
  //     meridiem = "PM";
  //   } else {
  //     meridiem = "AM";
  //   }
  //   const updateTime = moment(getTime, 'hh:mm').format('hh:mm') + " " + meridiem;
  //   return updateTime;
  // };

  // Checked All
  const checkedAll = () =>
  {
    const checkall = document.getElementById( "checkBoxAll" );
    const ele = document.querySelectorAll( ".clientCheckBox" );

    if ( checkall.checked )
    {
      ele.forEach( ( ele ) =>
      {
        ele.checked = true;
      } );
    } else
    {
      ele.forEach( ( ele ) =>
      {
        ele.checked = false;
      } );
    }
  };

  // Column
  const columns = useMemo(
    () => [
      // {
      //   Header: <input type="checkbox" id="checkBoxAll" onClick={ () => checkedAll() } />,
      //   Cell: ( cellProps ) =>
      //   {
      //     return <input type="checkbox" className="clientCheckBox" value={ cellProps.row.original.id } />;
      //   },
      //   id: '#',
      // },
      {
        Header: props.t( "Last Name" ),
        accessor: "last_name",
        filterable: false,
      },
      {
        Header: props.t( "First Name" ),
        accessor: "first_name",
        filterable: false,
      },
      {
        Header: props.t( "Email" ),
        accessor: "email",
        filterable: false,
      },
      {
        Header: props.t( "Phone number" ),
        accessor: "telephone",
        filterable: false,
      },
      // {
      //   Header: props.t( "Etat" ),
      //   accessor: "etat",
      //   filterable: false,
      //   Cell: ( client ) => (
      //     <span className={
      //       client.row.original.etat === "Activer" ? "badge badge-soft-success me-1" :
      //         client.row.original.etat === "Desactiver" ? "badge badge-soft-danger me-1" : "badge badge-soft-warning me-1"
      //     } >{ client.row.original.etat }</span>

      //   ),
      // },
      {
        Header: props.t( "Action" ),
        Cell: ( cellProps ) =>
        {
          const clientData = cellProps.row.original;
          const clientDataId = cellProps.row.original.id;
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item" title={ props.t( "Voir" ) }>
                <Link
                  to={ `/client/${ clientDataId }` }
                  className="btn btn-sm btn-success d-inline-block"
                  onClick={ () =>
                  {
                    const clientData = cellProps.row.original;
                    setInfo( clientData );
                  } }
                >
                  <i className="ri-eye-fill align-bottom"></i>
                </Link>
              </li>
              {/* { clientData.etat === "Activer" ?
                <li className="list-inline-item" title={ props.t( "Désactiver" ) }>
                  <Link to="#" className="text-danger d-inline-block"
                    onClick={ ( e ) =>
                    {
                      e.preventDefault();
                      const clientData = cellProps.row.original
                      handlerefuse( clientDataId )
                    } }>
                    <i className="ri-close-line align-bottom"></i>
                  </Link>
                </li> : <li className="list-inline-item" title={ props.t( "Activer" ) }>
                  <Link to="#" className="text-success d-inline-block"
                    onClick={ ( e ) =>
                    {
                      e.preventDefault();
                      const clientData = cellProps.row.original
                      handleaccept( clientDataId )
                    } }>
                    <i className="ri-check-line align-bottom"></i>
                  </Link>
                </li>
              } */}
            </ul>
          );
        },
      },
    ],
    [ toggle, props ]
  );

  // SideBar Client Deatail
  const [ info, setInfo ] = useState( [] );

  document.title = props.t( "Clients | Takci" );
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={ props.t( "Clients" ) } pageTitle="Takci" />
          <Row>
            { clients.length > 0 &&
              <Col lg={ 12 }>
                <Card>
                  <CardHeader>
                    <div className="d-flex justify-content-end align-items-center">
                      {/* <h2>{props.t("Customers List")}</h2> */ }
                      <div className="flex-shrink-0">
                        <button
                          disabled={ clients.length < 0 }
                          type="button"
                          className="btn"
                          style={ { color: "#eac22f" } }
                          onClick={ () => setIsExportCSV( true ) }
                        >
                          <i className="ri-file-download-line align-bottom me-1"></i>{ " " }
                          { props.t( "Export" ) }
                        </button>
                      </div>
                    </div>{ " " }
                  </CardHeader>
                </Card>
              </Col>
            }
            <Col xxl={ 12 }>
              <Card id="clientList">
                <CardBody className="pt-0">
                  <div>
                    { !loading ? (
                      clients.length > 0 ? (
                        <>
                          <ExportCSVModal
                            show={ isExportCSV }
                            onCloseClick={ () => setIsExportCSV( false ) }
                            data={
                              clients.length > 0
                                ? clients
                                : []
                            }
                          />

                          <TableContainer
                            columns={ columns }
                            data={
                              clients.length > 0
                                ? clients
                                : []
                            }
                            isGlobalFilter={ true }
                            isAddUserList={ false }
                            customPageSize={ 8 }
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-3"
                            tableClass="align-middle table-nowrap"
                            theadClass="table-light"
                            handleAdminClick={ handleClientClicks }
                            isAdminsFilter={ !( clients && clients.length > 0 ) }
                          />
                        </>
                      ) : (
                        <Col
                          lg="12"
                          className="p-4 border-top border-top-dashed"
                        >
                          <h6 className="text-muted text-uppercase fw-semibold mb-4">
                            Aucun Client disponible
                          </h6>
                        </Col>
                      )
                    ) : (
                      <>
                        <div className="text-center my-3">
                          <Loader style={ { color: "#014c94" } } />
                          <h2>Chargement...</h2>
                        </div>
                      </>
                    ) }
                  </div>

                  {/* <div>
                    {
                      // (clients.length > 0) 
                      // ? 
                      // (
                      //   <TableContainer
                      //     columns={columns}
                      //     data={(clients || [])}
                      //     isGlobalFilter={true}
                      //     isAddUserList={false}
                      //     customPageSize={8}
                      //     className="custom-header-css"
                      //     divClass="table-responsive table-card mb-3"
                      //     tableClass="align-middle table-nowrap"
                      //     theadClass="table-light"
                      //     handleClientClick={handleClientClicks}
                      //   />
                      // ) 
                      // : 
                      ( <TableContainer
                        columns={ columns }
                        data={ ( [] ) }
                        isGlobalFilter={ true }
                        isAddUserList={ false }
                        customPageSize={ 8 }
                        className="custom-header-css"
                        divClass="table-responsive table-card mb-3"
                        tableClass="align-middle table-nowrap"
                        theadClass="table-light"
                        handleClientClick={ handleClientClicks }
                        isClientsFilter={ true }
                      /> )
                    }
                  </div> */}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer closeButton={ false } />
        </Container>
      </div>
    </React.Fragment>
  );
};

Client.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter( withTranslation()( Client ) );
